/**
* @summary - Component that Provides RI SCHEDULE functionality
* @autor vengateshwaran k
* @since 2024-06-21
*/
import { Box, Button, Dialog, DialogContent, DialogTitle, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch } from "react-redux";
import { useLocation } from "react-router";
import { useNavigate } from 'react-router-dom';
import commonMasterRepository from "../../api/repositories/commonMasterRepository";
import PpmPlannerRepository from '../../api/repositories/ppmPlannerRepository';
import PremitiveMaintenanceRepository from "../../api/repositories/premitiveMaintenanceRepository";
import RoutineInspectionRepository from "../../api/repositories/routineInspectionRepository";
import { DefaultCard } from "../../assets/styled-components/card";
import ActionButtons from "../commoncomponents/ActionButtons";
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import CustomDatePicker from "../commoncomponents/CustomDatePicker";
import CustomDialog from '../commoncomponents/CustomDialog';
import CustomSelectInput from '../commoncomponents/CustomSelectInput';
import CustomTextField from "../commoncomponents/CustomTextField";
import CustomTextFieldWithSearch from "../commoncomponents/CustomTextFieldWithSearch";
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import {
  addDays,
  addMonths,
  addWeeks,
  endOfMonth,
  endOfYear,
  format,
  getDate,
  getMonth,
  getWeek,
  getYear,
  isBefore,
  isValid,
  parse,
  setDate,
  startOfDay,
} from "date-fns";
import PpmGenerationRepository from "../../api/repositories/ppmGenerationRepository";
import CustomTextArea from "../commoncomponents/CustomTextArea";
import PageLoader from "../commoncomponents/PageLoader";
import { values } from "pdf-lib";
const RoutineInspectionCreate = ({ setPeriodForShowSchedule, getMode, facilityId, companyId, setRIId, handleServiceType, assetNoForShowSchedule, taskCodeForShowSchedule, predictiveId, selectedServiceType, setAssetNoForShowSchedule, setLocationDescForShowSchedule, setLocationCodeForShowSchedule }) => {

  const location = useLocation();
  const [serviceType, setServiceType] = useState(null);
  const [serviceTypeOptions, setServiceTypeOptions] = useState([]);
  const [workGroup, setWorkGroup] = useState(null);
  const [workGroupOptions, setWorkGroupOptions] = useState([]);
  const [year, setYear] = useState(null);
  const [yearOptions, setYearOptions] = useState([]);
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [nextDate, setNextDate] = useState();
  const [assetTypeCode, setAssetTypeCode] = useState();
  const [assetTypeCodeDescription, setAssetTypeCodeDescription] = useState();
  const [userLocationCode, setUserLocationCode] = useState();
  const [userLocationDescription, setUserLocationDescription] = useState();
  const [model, setModel] = useState();
  const [disableUpdateButton, setDisableUpdateButton] = useState(false);
  const [serialNo, setSerialNo] = useState();
  const [assetClassification, setAssetClassification] = useState();
  const [assetNo, setAssetNo] = useState();
  const [assetOptions, setAssetOptions] = useState();
  const [taskCodeOptions, setTaskCodeOptions] = useState();
  const [taskCode, setTaskCode] = useState();
  const [period, setPeriod] = useState();
  const [assignee, setAssignee] = useState();
  const [routineInspectionDetails, setRoutineInspectionDetails] = useState();
  const [assigneeOptions, setAssigneeOptions] = useState([]);
  const statusOptions = [{ label: "Active", id: 1, value: true, default: true }, { label: "Inactive", id: 2, value: false, default: false }];
  const [status, setStatus] = useState(
    (location?.state?.mode === 'edit' || location?.state?.mode === 'view') ? statusOptions?.find((item) => item?.label === location?.state?.isactive) :
      statusOptions?.find((item) => item?.default === true));
  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
  const [scheduledFrequency, setScheduledFrequency] = useState(1);
  const [agreedDate, setAgreedDate] = useState();
  const [isAddNew, setIsAddNew] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [isStatusRIDetailsChanged, setIsStatusRIDetailsChanged] = useState(false);
  const [isAssigneeTaskCodeChanged, setIsAssigneeTaskCodeChanged] = useState(false);
  const [isFrequencyDateChanged, setIsFrequencyDateChanged] = useState(false);
  const [allTracks, setAllTracks] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disableAndMandatoryFieldHandleForUserLocation, setDisableAndMandatoryFieldHandleForUserLocation] = useState(false);
  const [disableAndMandatoryFieldHandleForAssetNo, setDisableAndMandatoryFieldHandleForAssetNo] = useState(false);
  const [userLocationCodeOptions, setUserLocationCodeOptions] = useState([]);
  const [preventSaveDuplicateRecord, setPreventSaveDuplicateRecord] = useState(false);
  const [userDepartment, setUserDepartment] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenForAsset, setIsModalOpenForAsset] = useState(false);
  const [gridApi, setGridApi] = useState({});
  const [gridAPIS, setGridAPIS] = useState({});

  const handleAssetClick = (newValue) => {
    runOnceForAssetChange.current = false;
    let label = newValue?.label;
    setAssetNo({ ...newValue, label: label });
    setUserLocationCode(userLocationCodeOptions?.find((item) => item?.label === newValue?.locationcode));
    if (newValue?.value === "") {
      setDisableAndMandatoryFieldHandleForUserLocation(false);
      setAssetTypeCode("");
      setAssetTypeCodeDescription("");
      setUserLocationCode("");
      setUserLocationCode({ label: '', value: '' });
      setModel("");
      setUserDepartment("");
      setSerialNo("");
      setAssetClassification("");
    }
    if (newValue?.label !== "") {
      setAssetTypeCode(newValue?.typecode);
      setAssetTypeCodeDescription(newValue?.typedescription);
      setModel(newValue?.model);
      setSerialNo(newValue?.serialno);
      setAssetClassification(newValue?.assetclassification);
      setIsChanged(true);
      assetNoForShowSchedule({ ...newValue, label: newValue?.value });
      setDisableAndMandatoryFieldHandleForUserLocation(true);
      setErrors({ ...errors, assetNo: null, userLocationCode: '' });
    }
    // Close the modal after asset selection
    handleCloseModalForAsset();
  };
  const columns = [
    {
      headerName: 'Asset No',
      field: 'label',
      width: 150,
      cellRenderer: (params) => (
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            handleAssetClick(params.data);
          }}
          style={{
            color: 'blue',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
        >
          {params.value}
        </a>
      ),
    },
    { headerName: 'Description', field: 'assetdesc', width: 200 },
    { headerName: 'Service', field: 'serviceName', width: 100, valueGetter: () => `${serviceType?.label}`, },
    { headerName: 'Location', field: 'locationdesc', width: 150 },
    { headerName: 'Work Group & Work Group Description', field: 'workGroupcodeDesc', width: 150, valueGetter: () => `${workGroup?.label}-${workGroup.wgdesc}`, }

  ];

  const handleTaskCodeClick = (newValue) => {
    setTaskCode({ ...newValue, label: newValue?.value });

    if (newValue?.label !== "") {
      taskCodeForShowSchedule(newValue?.value);
      setErrors({ ...errors, taskCode: null });
      setIsChanged(true);
    }

    // Close the modal after asset selection
    handleCloseModal();
  };

  const columnsTaskCode = [
    {
      headerName: 'Task Code',
      field: 'label',
      width: 150,
      cellRenderer: (params) => (
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            handleTaskCodeClick(params.data);
          }}
          style={{
            color: 'blue',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
        >
          {params.value}
        </a>
      ),
    },
    { headerName: 'Task Description', field: 'taskdesc', width: 200 },
    { headerName: 'Service', field: 'serviceName', width: 100, valueGetter: () => `${serviceType?.label}`, },
    { headerName: 'Work Group & Work Group Description', field: 'wgCode', width: 150, valueGetter: () => `${workGroup?.label}-${workGroup.wgdesc}` },
  ];
  const colDefs = [
    {
      headerName: "",
      children: [
        {
          field: "assetno", headerName: "Asset No",

        },
        {
          field: "assetdesc", headerName: "Asset Description",

        },
        {
          field: "taskcode", headerName: "Task Code",

        },
      ]
    },
    {
      headerName: "Schedule & Target Date Details",
      children: [
        {
          field: "scheduledfrequency", headerName: "Scheduled Frequency",
        },
        {
          field: "period", headerName: "Period",
        },
        {
          field: "targetdate", headerName: "Target Date",
        },
      ]
    },
    {
      headerName: "",
      children: [
        {
          field: "nextppmdate", headerName: "Next PPM Date",
        },
        {
          field: "respondtype", headerName: "Respond Type",
        },
      ]
    }
  ];
  const [periodOptions, setPeriodOptions] = useState([]);

  const ReArrangeLabels = async (originalData, keyToRename, newKeyName) => {
    try {
      // Map over the original array and transform each object
      const rearrangedData = originalData?.map((item) => {
        // Destructure the item to extract the value of the key to rename
        const { [keyToRename]: originalValue, ...rest } = item;

        // Create a new object with the renamed key and other remaining properties
        return {
          [newKeyName]: String(originalValue), // Rename the key
          value: originalValue,
          ...rest, // Spread the remaining properties
        };
      });
      return rearrangedData;
    } catch (error) {
      //Console.log(error)
    }
  }
  const hasMounted = useRef(false);
  const workChangerunOnce = useRef(false);
  const locationCodeRef = useRef([]);
  const runOnceForAssetChange = useRef(false);

  const fetchOptions = async () => {
    try {
      setIsChanged(false);
      getMode(location?.state?.mode);
      setLoading(true);
      setErrors({});
      if (location?.state?.service === "FEMS") {
        handleServiceType(location?.state?.serviceTypeDetails);
        const workgroupdetails = await commonMasterRepository.getWorkGroupDetails(facilityId);
        setWorkGroupOptions(workgroupdetails || []);

        if (workgroupdetails?.length > 0) {
          setWorkGroup(workgroupdetails?.find((item) => item?.id === location?.state?.femworkgroupdetailsId) || workgroupdetails?.find((item) => item?.label === 'W1'))
        }

      } else {
        handleServiceType(location?.state?.serviceTypeDetails);
        const workgroupdetails = await commonMasterRepository.getBemsWorkGroupDetails(facilityId);
        setWorkGroupOptions(workgroupdetails || []);
        if (workgroupdetails?.length > 0) {
          setWorkGroup(workgroupdetails?.find((item) => item?.id === location?.state?.bemworkgroupdetailsId) || workgroupdetails?.find((item) => item?.label === 'W8'))

        }
      }

      const responseMasters = await commonMasterRepository.getMasters(facilityId, companyId);
      setServiceTypeOptions(responseMasters);
      setServiceType(responseMasters?.find((item) => item?.label === location?.state.service) || responseMasters?.find((item) => item?.label === 'FEMS'))
      const maintanenceyear = await commonMasterRepository.getMaintanenceYear(facilityId);
      setYearOptions(maintanenceyear?.filter((item) => Number(item?.value) === new Date().getFullYear()));
      setYear(maintanenceyear?.find((item) => Number(item?.value) === new Date().getFullYear()) || maintanenceyear[(maintanenceyear?.length) - 1]);
      const userLocationOPtions = await PpmGenerationRepository.getLocationDetails(facilityId);
      locationCodeRef.current = userLocationOPtions;
      setUserLocationCodeOptions(userLocationOPtions);
      if (location?.state?.mode !== 'edit' && location?.state?.mode !== 'view') {
        const dropDownLists =
          await PpmPlannerRepository.ppmscheduleDropDownList(
            facilityId,
            companyId
          );
        const periodOptionsRearrange = await ReArrangeLabels(
          dropDownLists?.data?.femppmintervaltypes,
          "intervaltypedesc",
          "label"
        );
        setPeriodOptions(periodOptionsRearrange);
        setPeriod(
          periodOptionsRearrange?.find((item) => item?.value === "Weeks")
        );
        setPeriodForShowSchedule(periodOptionsRearrange?.find((item) => item?.value === "Weeks")?.label)
        const assigneeList = await PremitiveMaintenanceRepository.getStaffDetails(facilityId);
        if (assigneeList?.status !== 'error') {
          setAssigneeOptions(assigneeList);
        }
      }
    }
    catch (e) {
      //Console.log(e)
    } finally {
      if (location?.state?.mode == 'create') {
        setLoading(false);
      }

    }
  };


  useEffect(() => {
    if (!hasMounted.current) {
      //Console.log("EDIT OPTIONS");

      fetchOptions();
      hasMounted.current = true;
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if ((location.state.mode === "edit" || location.state.mode === "view")) {
        await setEdit();
      }
    }
    fetchData();
  }, [location.state])

  const setAssetNoField = async (assetNo) => {
    try {

      if (location.state?.service === 'BEMS') {
        const assetList = await RoutineInspectionRepository.getAllBemsAssetNoDetails(
          facilityId,
          location.state?.workgroupdetailsId
        );
        setAssetOptions(assetList);
        let value = assetList?.find((item) => item?.label === location.state.assetno);
        setAssetNo(value)
        setAssetTypeCodeDescription(value.typedescription);
        setAssetTypeCode(value.typecode);
        setModel(value.model);
        setSerialNo(value.serialno);
        setAssetClassification(value.assetclassification);
        setUserLocationCode(locationCodeRef.current?.find(item => item.label === location.state.locationcode));
        setUserLocationDescription(value?.locationdesc);
        setUserDepartment(locationCodeRef.current?.find(item => item.label === location.state.locationcode)?.departmentdesc);
        assetNoForShowSchedule(value);
        await new Promise((resolve) => setTimeout(resolve, 0)); // Allow React to render the loader before heavy work

      }
      if (location.state?.service === 'FEMS') {
        const assetList = await RoutineInspectionRepository.getAllAssetNoDetails(
          facilityId,
          location.state?.workgroupdetailsId
        );
        //Console.log(assetList, "assetList");
        
        setAssetOptions(assetList);
        let value = assetList?.find((item) => item?.label === location.state.assetno);
        setAssetNo(value)
        setAssetTypeCodeDescription(value.typedescription);
        setAssetTypeCode(value.typecode);
        setModel(value.model);
        setSerialNo(value.serialno);
        setAssetClassification(value.assetclassification);
        setUserLocationCode(locationCodeRef.current?.find(item => item.label === location.state.locationcode))
        setUserLocationDescription(value?.locationdesc);
        setUserDepartment(locationCodeRef.current?.find(item => item.label === location.state.locationcode)?.departmentdesc);
        setAssetNo(value)
        assetNoForShowSchedule(value);
        await new Promise((resolve) => setTimeout(resolve, 0)); // Allow React to render the loader before heavy work

      }
    }
    catch (error) {
      //Console.log(error);
    }

  }



  const fetchTaskCode = async () => {
    try {
      let workgroupdetailsId = (location.state.mode === "edit" || location.state.mode === "view") ? (serviceType?.label === 'BEMS' || location?.state?.service === 'BEMS') ? location?.state?.bemworkgroupdetailsId != undefined ? location?.state?.bemworkgroupdetailsId : workGroup?.id : location?.state?.femworkgroupdetailsId != undefined ? location?.state?.femworkgroupdetailsId : workGroup?.id : assetNo?.workgroupdetailsId;
      if (serviceType?.label == 'BEMS' || location?.state?.service == 'BEMS') {
        setAssetTypeCode(assetNo?.typecode);
        setAssetTypeCodeDescription(assetNo?.typedescription);
        setModel(assetNo?.model);
        setSerialNo(assetNo?.serialno);
        setAssetClassification(assetNo?.assetclassification);
        const taskCodes = await PremitiveMaintenanceRepository.getBemsTaskCodeDetails(
          facilityId,
          workgroupdetailsId
        );

        setTaskCodeOptions(taskCodes);
        const assigneeList = await PremitiveMaintenanceRepository.getStaffDetails(facilityId);
        setAssigneeOptions(assigneeList);
        const dropDownLists =
          await PpmPlannerRepository.ppmscheduleDropDownList(
            facilityId,
            companyId
          );
        const periodOptionsRearrange = await ReArrangeLabels(
          dropDownLists?.data?.femppmintervaltypes,
          "intervaltypedesc",
          "label"
        );
        setPeriodOptions(periodOptionsRearrange);
        if (location.state.mode === "edit" || location.state.mode === "view") {
          setRIId(location?.state?.id);
          setTaskCode(taskCodes?.find((item) => item?.label == location?.state?.taskcode));
          taskCodeForShowSchedule(taskCodes?.find((item) => item?.label === location?.state?.taskcode)?.value);
          const assigneeList = await PremitiveMaintenanceRepository.getStaffDetails(facilityId);
          if (assigneeList && assigneeList?.status !== 'error') {
            setAssigneeOptions(assigneeList);
            setAssignee(assigneeList?.find((item) => item?.label === location?.state?.employeename))
          }
          setPeriod(periodOptionsRearrange?.find((item) => item?.value === location?.state?.intervaltypedesc));
          setPeriodForShowSchedule(periodOptionsRearrange?.find((item) => item?.value === location?.state?.intervaltypedesc)?.label);
        }
        await new Promise((resolve) => setTimeout(resolve, 0)); // Allow React to render the loader before heavy work

      } else if (serviceType?.label == 'FEMS' || location?.state?.service == 'FEMS') {
        setAssetTypeCode(assetNo?.typecode);
        setAssetTypeCodeDescription(assetNo?.typedescription);
        setModel(assetNo?.model);
        setSerialNo(assetNo?.serialno);
        setAssetClassification(assetNo?.assetclassification);
        const taskCodes = await PremitiveMaintenanceRepository.getTaskCodeDetails(
          facilityId,
          workgroupdetailsId
        );
        setTaskCodeOptions(taskCodes);
        const assigneeList = await PremitiveMaintenanceRepository.getStaffDetails(facilityId);
        setAssigneeOptions(assigneeList);
        const dropDownLists =
          await PpmPlannerRepository.ppmscheduleDropDownList(
            facilityId,
            companyId
          );
        const periodOptionsRearrange = await ReArrangeLabels(
          dropDownLists?.data?.femppmintervaltypes,
          "intervaltypedesc",
          "label"
        );
        setPeriodOptions(periodOptionsRearrange);
        if (location.state.mode == "edit" || location.state.mode == "view") {
          setRIId(location?.state?.id);
          setTaskCode(taskCodes?.find((item) => item?.label === location?.state?.taskcode))
          taskCodeForShowSchedule(taskCodes?.find((item) => item?.label === location?.state?.taskcode)?.value);
          const assigneeList = await PremitiveMaintenanceRepository.getStaffDetails(facilityId);
          if (assigneeList && assigneeList?.status !== 'error') {
            setAssigneeOptions(assigneeList);
            setAssignee(assigneeList?.find((item) => item?.label === location?.state?.employeename))
          }
          setPeriod(periodOptionsRearrange?.find((item) => item?.value === location?.state?.intervaltypedesc));
          setPeriodForShowSchedule(periodOptionsRearrange?.find((item) => item?.value === location?.state?.intervaltypedesc)?.label);
        }
        await new Promise((resolve) => setTimeout(resolve, 0)); // Allow React to render the loader before heavy work


      }
    }
    catch (e) {
      //Console.log(e)
    }
    finally {
      // setLoading(false);
      // await new Promise((resolve) => setTimeout(resolve, 0)); // Allow React to render the loader before heavy work

    }
  }


  const setEdit = async () => {
    //Console.log(location.state, "location.state");
    

    try {
      if ((location.state?.mode === "edit" || location.state?.mode === "view") && (location?.state?.assetno != "" || location?.state?.assetno == undefined)) {
        // setLoading(true);
        ////Console.log("IF PART");

        if (location?.state?.service === "FEMS") {
          const scheduleTracksFems = await RoutineInspectionRepository.getRIShowSchedule(location?.state?.id);
          setAllTracks(scheduleTracksFems?.data);
          await fetchTaskCode();
          setTaskCode({ id: location?.state?.femtaskdetailsId || location?.state?.bemtaskdetailsId, label: `${location?.state?.taskcode || location?.state?.taskcode  ||""}`, value: location?.state?.taskcode  || location?.state?.taskcode ||"" })
          setAssignee({ id: location?.state?.assigneeid || "", label: location?.state?.employeename || "", value: location?.state?.employeename || "" });
          setPeriod({ id: location?.state?.femppmintervaltypeId || "", label: location?.state?.intervaltypedesc || "", value: location?.state?.intervaltypedesc || "" });
          setAgreedDate(format(new Date(location?.state?.agreeddate), 'dd/MM/yyyy'));
          setNextDate(location?.state?.targetdateChanged);
          // setNextDate(format(new Date(location?.state?.targetdate), 'dd/MM/yyyy'));
          setScheduledFrequency(location?.state?.frequencyunit);
          setRoutineInspectionDetails(location?.state?.routinedetail);
          await setAssetNoField(location?.state?.assetno);
          await new Promise((resolve) => setTimeout(resolve, 2000)); // Allow React to render the loader before heavy work

        } else {
          const scheduleTracksBems = await RoutineInspectionRepository.getBemsRIShowSchedule(location?.state?.id);
          setAllTracks(scheduleTracksBems?.data);
          await fetchTaskCode();
          // setTaskCode({ id: location?.state?.femtaskdetailsId, label: `${location?.state?.taskcode || ""}`, value: location?.state?.taskcode })
          setTaskCode({ id: location?.state?.femtaskdetailsId || location?.state?.bemtaskdetailsId, label: `${location?.state?.taskcode || location?.state?.taskcode  ||""}`, value: location?.state?.taskcode  || location?.state?.taskcode ||"" })
          setAssignee({ id: location?.state?.assigneeid || "", label: location?.state?.employeename || "", value: location?.state?.employeename || "" });
          setPeriod({ id: location?.state?.bemppmintervaltypeId || "", label: location?.state?.intervaltypedesc || "", value: location?.state?.intervaltypedesc || "" });
          await setAssetNoField(location?.state?.assetno);
          setAgreedDate(format(new Date(location?.state?.agreeddate), 'dd/MM/yyyy'));
          setNextDate(location?.state?.targetdateChanged);
          // setNextDate(format(new Date(location?.state?.targetdate), 'dd/MM/yyyy'));
          setScheduledFrequency(location?.state?.frequencyunit);
          setRoutineInspectionDetails(location?.state?.routinedetail);
          await new Promise((resolve) => setTimeout(resolve, 2000)); // Allow React to render the loader before heavy work

        }
      } else {
        if (location?.state?.service === "FEMS") {
          const scheduleTracksFems = await RoutineInspectionRepository.getRIShowSchedule(location?.state?.id);
          setAllTracks(scheduleTracksFems?.data);
        } else {
          const scheduleTracksBems = await RoutineInspectionRepository.getBemsRIShowSchedule(location?.state?.id);
          setAllTracks(scheduleTracksBems?.data);
        }
        const getServiceType = location?.state?.service === "FEMS" ? "fem" : "bem"
        setDisableAndMandatoryFieldHandleForAssetNo(true);
        // setLoading(true);
        setAgreedDate(format(new Date(location?.state?.agreeddate), 'dd/MM/yyyy'));
        setNextDate(location?.state?.targetdateChanged);
        // setNextDate(format(new Date(location?.state?.targetdate), 'dd/MM/yyyy'));
        setScheduledFrequency(location?.state?.frequencyunit);
        setRoutineInspectionDetails(location?.state?.routinedetail);
        await fetchTaskCode();
        setTaskCode({ id: location?.state?.[`${getServiceType}taskdetailsId`], label: `${location?.state?.taskcode || ""}`, value: location?.state?.taskcode })
        setAssignee({ id: location?.state?.assigneeid || "", label: location?.state?.employeename || "", value: location?.state?.employeename || "" });
        setPeriod({ id: location?.state?.[`${getServiceType}ppmintervaltypeId`] || "", label: location?.state?.intervaltypedesc || "", value: location?.state?.intervaltypedesc || "" });
        const userLocationOPtions = await PpmGenerationRepository.getLocationDetails(facilityId);
        setUserLocationCode(userLocationOPtions?.find(item => item.label === location.state.locationcode));
        setUserLocationDescription(location.state.locationdesc);
        setUserDepartment(userLocationOPtions?.find(item => item.label === location.state.locationcode)?.departmentdesc);

        setIsChanged(false);
        setDisableAndMandatoryFieldHandleForAssetNo(true);
      }
    } catch (error) {
      ////Console.log(error)
    }
    finally {
      setLoading(false);  // End loading after the data is fetched      
    }
  }
  const setEmpty = async () => {
    setAssetNo({ label: '', value: '' });
    setTaskCode({ label: '', value: '' });
    setAssignee({ label: '', value: '' });
    setAssetTypeCode('');
    setAssetTypeCodeDescription('');
    setUserLocationCode({ label: '', value: '' });
    setUserLocationDescription('');
    setAgreedDate('');
    setNextDate('');
    setRoutineInspectionDetails('');
  }
  const setDefault = async () => {
    // setIsChanged(false);
    await setEmpty();
    setModel('');
    setAssetClassification('');
    setSerialNo('');
    setDisableAndMandatoryFieldHandleForAssetNo(false);
    setDisableAndMandatoryFieldHandleForUserLocation(false);
    setServiceType(serviceTypeOptions?.find((item) => item?.label === "FEMS"));
    setStatus(statusOptions?.find((item) => item?.default === true))
    setYear(yearOptions?.find((item) => Number(item?.value) === new Date().getFullYear()));
    setScheduledFrequency(1);
    setPeriod(periodOptions?.find((item) => item.label === "Weeks"));
    setPeriodForShowSchedule(periodOptions?.find((item) => item.label === "Weeks")?.label);
    setErrors((prevErrors) => ({ ...prevErrors, assetNo: "", status: "", serviceType: "", taskCode: "", typeCode: "", agreedDate: "", scheduledFrequency: "", period: "", assignee: "", year: "", routineInspectionDetails: "", userLocationCode: "", workGroup: '' }));
  }
  const workGoupChange = useMemo(() => {
    const fetchOptions = async () => {
      try {
        if (location.state.mode != 'create') {
          if (serviceType?.label === 'BEMS') {
            const assetNo = await RoutineInspectionRepository.getBemsAssetNoDetails(
              facilityId,
              location.state.bemworkgroupdetailsId
            );
            setAssetOptions(assetNo);
            handleServiceType(serviceType);
            const taskCodes = await PremitiveMaintenanceRepository.getBemsTaskCodeDetails(
              facilityId,
              location.state.bemworkgroupdetailsId
            );
            setTaskCodeOptions(taskCodes);

          }
          if (serviceType?.label === 'FEMS') {
            const assetNo = await RoutineInspectionRepository.getAssetNoDetails(
              facilityId,
              location.state.femworkgroupdetailsId
            );
            setAssetOptions(assetNo);
            handleServiceType(serviceType);
            const taskCodes = await PremitiveMaintenanceRepository.getTaskCodeDetails(
              facilityId,
              workGroup?.id
            );
            setTaskCodeOptions(taskCodes);
          }
        } else {
          setLoading(true);
          let resultArray = [];
          if (serviceType?.label === 'BEMS') {
            const taskCodes = await PremitiveMaintenanceRepository.getBemsTaskCodeDetails(
              facilityId,
              workGroup?.id
            );
            setTaskCodeOptions(taskCodes);
            const assetNo = await RoutineInspectionRepository.getBemsAssetNoDetails(
              facilityId,
              workGroup?.id
            );
            if (location?.state?.pdmList?.length > 0) {
              resultArray = assetNo.filter(item1 =>
                !location?.state?.pdmList?.some(item2 => item1.label === item2.assetNo)
              );
            } else {
              resultArray = assetNo
            }
            setAssetOptions(resultArray);
            handleServiceType(serviceType);
          }
          if (serviceType?.label === 'FEMS') {
            //  const assetNo = await PremitiveMaintenanceRepository.getAssetNoDetails(facilityId);

            const taskCodes = await PremitiveMaintenanceRepository.getTaskCodeDetails(
              facilityId,
              workGroup?.id
            );
            setTaskCodeOptions(taskCodes);
            // const workgroupdetails = await commonMasterRepository.getWorkGroupDetails(facilityId);
            // setWorkGroupOptions(workgroupdetails||[]);
            // if(workgroupdetails?.length>0){
            //   setWorkGroup(workgroupdetails?.find((item) => item?.id === location?.state?.workgroupId) || workgroupdetails?.find((item) => item?.label === workGroup?.label))

            //   }  
            const assetNo = await RoutineInspectionRepository.getAssetNoDetails(
              facilityId,
              workGroup?.id
            );
            if (location?.state?.pdmList?.length > 0) {
              resultArray = assetNo.filter(item1 =>
                !location?.state?.pdmList?.some(item2 => item1.label === item2.assetNo)
              );
            } else {
              resultArray = assetNo
            }
            setAssetOptions(resultArray);
            handleServiceType(serviceType);
          }
        }
      }
      catch (e) {
        ////Console.log(e)
      }
      finally {
        if (location.state.mode == 'create') {
          setLoading(false);
        }
      }
    }

    if (!workChangerunOnce.current) {

      fetchOptions();
      workChangerunOnce.current = true;
    }
  }, [workGroup]);

  const serviceTypeChange = useMemo(() => {
    const fetchOptions = async () => {
      try {
        if (serviceType?.label === 'BEMS') {

          workChangerunOnce.current = false;
          const workgroupdetails = await commonMasterRepository?.getBemsWorkGroupDetails(facilityId);
          setWorkGroupOptions(workgroupdetails || []);
          setWorkGroup(workgroupdetails?.find((item) => item?.id === location.state.bemworkgroupdetailsId) || workgroupdetails?.find((item) => item?.label === 'W8'))

        }
        if (serviceType?.label === 'FEMS') {

          workChangerunOnce.current = false;
          const workgroupdetails = await commonMasterRepository?.getWorkGroupDetails(facilityId);
          setWorkGroupOptions(workgroupdetails || []);
          // const workGroupSelection=selectedWorkgroup.label===""? workgroupdetails?.find((item) => item?.label === 'W1') : workgroupdetails?.find((item) => item?.label === selectedWorkgroup?.label)
          // setWorkGroup(workGroupSelection?.label===undefined?workgroupdetails?.find((item) => item?.label === 'W1'):workGroupSelection)
          setWorkGroup(workgroupdetails?.find((item) => item?.id === location.state.femworkgroupdetailsId) || workgroupdetails?.find((item) => item?.label === 'W1'))

        }
      }
      catch (e) {
        ////Console.log(e)
      }

    }
    fetchOptions();
  }, [serviceType]);

  const getTaskCode = useMemo(() => {
    if (assetNo?.label != '' && !runOnceForAssetChange && location.state.mode == 'create') {
      fetchTaskCode();
      runOnceForAssetChange.current = true;
    }
  }, [assetNo])


  // //This is the Dynamicaly change the Nextdate field based on the Scheduled frequency,Period,AgreedDate
  // const onChangeHandle = (value, type) => {
  //   const currentYear = new Date().getFullYear(); //To get the current year
  //   const currentMonth = new Date().getMonth(); //To get the current month

  //   const adjustDateToCurrentYearAndMonth = (date) => {
  //     let year = getYear(date);
  //     let month = getMonth(date);
  //     let day = getDate(date);

  //     if (year < currentYear) {
  //       year = currentYear;
  //     }

  //     if (year === currentYear && month < currentMonth) {
  //       month = currentMonth;
  //     }

  //     date = new Date(year, month, day);
  //     return date;
  //   };

  //   if (period) {
  //     var periodForPpm = period?.value;
  //   }

  //   //Calculate the Next date based on the props
  //   const calculateNextDate = (startFromDate, frequencyUnit, intervalTypeDesc) => {
  //     let nextDate = startFromDate;
  //     const currentDate = new Date();

  //     if (intervalTypeDesc === "Weeks") { // Weeks based next date
  //       nextDate = addWeeks(startFromDate, frequencyUnit);
  //       while (isBefore(nextDate, currentDate)) {
  //         nextDate = addWeeks(nextDate, frequencyUnit);
  //       }
  //     } else if (intervalTypeDesc === "Months") { // Month based next date
  //       nextDate = addMonths(startFromDate, frequencyUnit);
  //       while (isBefore(nextDate, currentDate)) {
  //         nextDate = addMonths(nextDate, frequencyUnit);
  //       }
  //     } else if (intervalTypeDesc === "Bi-Monthly") { // Bi-Month(15 days once) based next date
  //       nextDate = addDays(startFromDate, 15 * frequencyUnit);
  //       while (isBefore(nextDate, currentDate)) {
  //         nextDate = addDays(nextDate, 15 * frequencyUnit);
  //       }
  //     } else if (intervalTypeDesc === "Daily") { // Daily based next date
  //       nextDate = addDays(startFromDate, frequencyUnit);
  //       while (isBefore(nextDate, currentDate)) {
  //         nextDate = addDays(nextDate, frequencyUnit);
  //       }
  //     }

  //     return adjustDateToCurrentYearAndMonth(nextDate);
  //   };

  //   if (type === "agreedDate") { //Once Agreed Date changed means set the nextdate
  //     let Tdate = parse(value, "dd/MM/yyyy", new Date());
  //     let scheduledFrequencyPeriod = scheduledFrequency || 0;

  //     let nextPPMDate = calculateNextDate(Tdate, scheduledFrequencyPeriod, periodForPpm);
  //     const formattedDate = format(nextPPMDate, "dd/MM/yyyy");
  //     setNextDate(formattedDate);
  //   } else if (type === "scheduledfrequency" && agreedDate) { //Once Scheduled Frequency changed means set the nextdate
  //     let Tdate = parse(agreedDate, "dd/MM/yyyy", new Date());
  //     let scheduledFrequencyPeriod = value || 0;

  //     let nextPPMDate = calculateNextDate(Tdate, scheduledFrequencyPeriod, periodForPpm);
  //     const formattedDate = format(nextPPMDate, "dd/MM/yyyy");
  //     setNextDate(formattedDate);
  //   } else if (type === "period" && agreedDate) { //Once Period changed means set the nextdate
  //     let Tdate = parse(agreedDate, "dd/MM/yyyy", new Date());
  //     let scheduledFrequencyPeriod = scheduledFrequency || 0;

  //     let nextPPMDate = calculateNextDate(Tdate, scheduledFrequencyPeriod, value?.value);
  //     const formattedDate = format(nextPPMDate, "dd/MM/yyyy");
  //     setNextDate(formattedDate);
  //   }
  // };


  const onChangeHandle = (value, type) => {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
  
    const adjustDateToCurrentYearAndMonth = (date) => {
      let year = getYear(date);
      let month = getMonth(date);
      let day = getDate(date);
  
      if (year < currentYear) {
        year = currentYear;
      }
  
      if (year === currentYear && month < currentMonth) {
        month = currentMonth;
      }
  
      return new Date(year, month, day);
    };
  
    if (period) {
      var periodForPpm = period?.value;
    }
  
    // Normalize interval type
    const normalizeIntervalType = (intervalTypeDesc) => {
      let normalizedType = intervalTypeDesc.trim().toLowerCase();
      if (normalizedType === "weeks") {
        return "weekly";
      }
      return normalizedType;
    };
  
    // Calculate the next date based on the given parameters
    const calculateNextDate = (startFromDate, frequencyUnit, intervalTypeDesc) => {
      if (!frequencyUnit || frequencyUnit <= 0) {
        return adjustDateToCurrentYearAndMonth(startFromDate);
      }
  
      let normalizedFrequency = normalizeIntervalType(intervalTypeDesc);
      let nextDate = startFromDate;
      const currentDate = new Date();
  
      switch (normalizedFrequency) {
        case "weekly":
          do {
            nextDate = addWeeks(nextDate, frequencyUnit);
          } while (isBefore(nextDate, currentDate));
          break;
        case "months":
          do {
            nextDate = addMonths(nextDate, frequencyUnit);
          } while (isBefore(nextDate, currentDate));
          break;
        case "bi-monthly":
          do {
            nextDate = addDays(nextDate, 15 * frequencyUnit);
          } while (isBefore(nextDate, currentDate));
          break;
        case "daily":
          do {
            nextDate = addDays(nextDate, frequencyUnit);
          } while (isBefore(nextDate, currentDate));
          break;
        default:
          break;
      }
  
      return adjustDateToCurrentYearAndMonth(nextDate);
    };
  
    if (type === "agreedDate") {
      let Tdate = parse(value, "dd/MM/yyyy", new Date());
      let scheduledFrequencyPeriod = scheduledFrequency || 0;
  
      let nextPPMDate = calculateNextDate(Tdate, scheduledFrequencyPeriod, periodForPpm);
      setNextDate(format(nextPPMDate, "dd/MM/yyyy"));
    } else if (type === "scheduledfrequency" && agreedDate) {
      let Tdate = parse(agreedDate, "dd/MM/yyyy", new Date());
      let scheduledFrequencyPeriod = value || 0;
  
      let nextPPMDate = calculateNextDate(Tdate, scheduledFrequencyPeriod, periodForPpm);
      setNextDate(format(nextPPMDate, "dd/MM/yyyy"));
    } else if (type === "period" && agreedDate) {
      let Tdate = parse(agreedDate, "dd/MM/yyyy", new Date());
      let scheduledFrequencyPeriod = scheduledFrequency || 0;
  
      let nextPPMDate = calculateNextDate(Tdate, scheduledFrequencyPeriod, value?.value);
      setNextDate(format(nextPPMDate, "dd/MM/yyyy"));
    }
  };
  

  const handleAddNew = async () => {
    if (isChanged) {
     
      setIsAddNew(true);
      setCancelDialogOpen(true);
    } else {
      await setDefault();
    }
  };

  const handleCancel = () => {
    if (isChanged && location?.state?.mode != "view") {
      setCancelDialogOpen(true);
    } else {
      navigate('/routineInspection');
    }
  };

  const handleCancelDialogConfirm = async () => {
    if (isAddNew) {
      setCancelDialogOpen(false);
      await setDefault();
      setIsAddNew(false);
      setIsChanged(false);

    } else {
      setCancelDialogOpen(false);
      setDefault();
      setIsChanged(false);
      navigate('/routineInspection', { replace: true });
    }
  };



  const generateDates = async (
    start,
    frequency,
    routineId,
    startFromDate,
    schFrequency,
    staffname
  ) => {

  
    const getCurrentDate = new Date();
    const currentYear = getCurrentDate.getFullYear();
    let initialDate = new Date(start);
  
    initialDate.setHours(0, 0, 0, 0);
    getCurrentDate.setHours(0, 0, 0, 0);
  
    // Ensure startFromDate is a valid date
    const startFrom = new Date(start);
    startFrom.setHours(0, 0, 0, 0);
  
    // Set end date to the end of the current year
    const endDate = new Date(currentYear, 11, 31);
    const datesArray = [];
    const originalDay = initialDate.getDate();

  
    let weekNumber = getWeek(initialDate);
    let schTrackYear = format(initialDate, "yyyy");
  
    let rows =
      serviceType?.label === "FEMS"
        ? {
            weekno: "",
            schtrackyear: "",
            startfromdate: "",
            targetdate: "",
            femroutineinspectscheduledetailId: routineId,
            femtaskdetailsId: taskCode?.id,
            isdeleted: false,
            staffid: staffname,
          }
        : {
            weekno: "",
            schtrackyear: "",
            startfromdate: "",
            targetdate: "",
            bemroutineinspectscheduledetailId: routineId,
            bemtaskdetailsId: taskCode?.id,
            isdeleted: false,
            staffid: staffname,
          };
  
    let currentDate = new Date(Math.max(initialDate, startFrom));
  
    // Normalize frequency input
    let normalizedFrequency = frequency.trim().toLowerCase();
    if (normalizedFrequency === "weeks") {
      normalizedFrequency = "weekly";
    }
  
    while (currentDate <= endDate) {
      if (currentDate >= startFrom) {
        datesArray.push({
          ...rows,
          targetdate: format(currentDate, "yyyy-MM-dd'T'HH:mm:ss"),
          weekno: getWeek(currentDate),
          schtrackyear: format(currentDate, "yyyy"),
          startfromdate: start,
        });
      }
  
      // Increment dates based on frequency and schFrequency
      switch (normalizedFrequency) {
        case "daily":
          currentDate = addDays(currentDate, schFrequency || 1);
          break;
        case "weekly":
          currentDate = addDays(currentDate, schFrequency ? schFrequency * 7 : 7);
          break;
        case "bi-monthly":
          currentDate = addMonths(currentDate, schFrequency * 2 || 2);
          break;
        case "months":
          currentDate = addMonths(currentDate, schFrequency || 1);
          const lastDayOfCurrentMonth = endOfMonth(currentDate).getDate();
          currentDate.setDate(Math.min(originalDay, lastDayOfCurrentMonth));
          break;
        default:
          console.warn("Invalid frequency:", frequency);
          return datesArray;
      }
  
      // Stop if we go past the end of the current year
      if (currentDate.getFullYear() > currentYear) break;
    }
  
    //Console.log("Generated Dates Array:", datesArray);
    return datesArray;
  };
  
  const handleSave = async () => {
    //Console.log("Save");

    try {
      setLoading(true);
      // Parse the date string
      const parsedDate = parse(nextDate, 'dd/MM/yyyy', new Date());
      // Extract the year as a number
      const yearValue = getYear(parsedDate);
      const currentYear = new Date().getFullYear();

      const withoutTimeZoneNextPpm = parse(
        agreedDate,
        "dd/MM/yyyy",
        new Date()
      );
      const parsedTargetDate = startOfDay(withoutTimeZoneNextPpm);
      const finalAgreedDate = format(
        parsedTargetDate,
        "yyyy-MM-dd'T'HH:mm:ss"
      );
      const finalAgreedDate1 = format(
        parsedTargetDate,
        "yyyy/MM/dd HH:mm:ss"
      );

      const withoutTimeZone = parse(nextDate, "dd/MM/yyyy", new Date());
      const parsedNextPpmDate = startOfDay(withoutTimeZone);
      const finalNextDate = format(
        parsedNextPpmDate,
        "yyyy-MM-dd'T'HH:mm:ss"
      );
      const date = new Date(withoutTimeZoneNextPpm);
      // Get the week number
      const weekNumber = getWeek(date);
      if (location?.state?.mode === "edit" || location?.state?.mode === "create") {
        let response;
        const payload = serviceType?.label === 'FEMS' ? {
          routineinspectiondate: finalAgreedDate,
          targetdate: finalNextDate,
          routinedetail: routineInspectionDetails,
          isdeleted: false,
          femassetregisterId: assetNo?.assetId,
          femtaskdetailsId: taskCode?.id,
          femppmintervaltypeId: period?.id,
          Userlocationid: userLocationCode?.id,
          Frequencyunit: scheduledFrequency,
          Facilityid: facilityId,
          assigneeid: assignee?.id,
          agreeddate: finalAgreedDate,
          isactive: status?.value,
          femworkgroupdetailsId: workGroup?.id,
          // staffid:assignee?.id
        } : {
          routineinspectiondate: finalAgreedDate,
          targetdate: finalNextDate,
          routinedetail: routineInspectionDetails,
          isdeleted: false,
          bemassetregisterId: assetNo?.assetId,
          bemtaskdetailsId: taskCode?.id,
          bemppmintervaltypeId: period?.id,
          Userlocationid: userLocationCode?.id,
          Frequencyunit: scheduledFrequency,
          Facilityid: facilityId,
          assigneeid: assignee?.id,
          agreeddate: finalAgreedDate,
          isactive: status?.value,
          bemworkgroupdetailsId: workGroup?.id,
          // staffid:assignee?.id

        };
        //Console.log(currentYear, "currentyear");

        //Console.log((location?.state?.schYear !== currentYear), "(location?.state?.schYear !== currentYear)");


        if ((isChanged && !preventSaveDuplicateRecord) || (location?.state?.schYear !== currentYear)) {
          setAssetNoForShowSchedule(assetNo?.assetId);
          if (isStatusRIDetailsChanged && !isFrequencyDateChanged) {
            response = location?.state?.mode === "create" ? serviceType?.label === 'FEMS' ? await RoutineInspectionRepository.createRI(payload) : await RoutineInspectionRepository.createBemsRI(payload) : serviceType?.label === 'FEMS' ? await RoutineInspectionRepository.updateRI({ ...payload, id: location?.state?.id }, location?.state?.id) : await RoutineInspectionRepository.updateBemsRI({ ...payload, id: location?.state?.id }, location?.state?.id);
            setRIId(response?.data?.id);
            setOpenDialog(true);

          } else if (isAssigneeTaskCodeChanged && !isFrequencyDateChanged) {
            response = location?.state?.mode === "create" ? serviceType?.label === 'FEMS' ? await RoutineInspectionRepository.createRI(payload) : await RoutineInspectionRepository.createBemsRI(payload) : serviceType?.label === 'FEMS' ? await RoutineInspectionRepository.updateRI({ ...payload, id: location?.state?.id }, location?.state?.id) : await RoutineInspectionRepository.updateBemsRI({ ...payload, id: location?.state?.id }, location?.state?.id);
            await RoutineInspectionRepository.updateRIAssigneorTaskCode(location?.state?.id, assignee?.id, taskCode?.id, serviceType?.label);
            setRIId(response?.data?.id);
            setOpenDialog(true);
          }
          else {
            //Console.log("ALL");

            response = location?.state?.mode === "create" ? serviceType?.label === 'FEMS' ? await RoutineInspectionRepository.createRI(payload) : await RoutineInspectionRepository.createBemsRI(payload) : serviceType?.label === 'FEMS' ? await RoutineInspectionRepository.updateRI({ ...payload, id: location?.state?.id }, location?.state?.id) : await RoutineInspectionRepository.updateBemsRI({ ...payload, id: location?.state?.id }, location?.state?.id);
            setRIId(response?.data?.id);

            //Console.log(response.status >= 200 && response.status <= 204, "response.status >= 200 && response.status <= 204");
            if (response.status >= 200 && response.status <= 204) {
              //Console.log(yearValue === Number(year?.value), "yearValue === Number(year?.value)");

              if (location?.state?.mode != "edit" && yearValue === Number(year?.value)) {
                //Console.log("INSIDE");

                const generatedDates = await generateDates(
                  finalAgreedDate1,
                  period?.label,
                  response?.data?.id,
                  finalNextDate,
                  scheduledFrequency,
                  assignee?.id
                );

                if (generatedDates?.length > 0) {
                  const setTracks = generatedDates?.map(async (item) => {
                    const updatePpmScheduleTracks = serviceType?.label === 'FEMS' ?
                      await RoutineInspectionRepository.addRIscheduleTracks(item) : await RoutineInspectionRepository.addBemsRIscheduleTracks(item);
                    return updatePpmScheduleTracks;
                  });

                  const updatePpmScheduleTracksInsert = await Promise.all(
                    setTracks
                  );
                  const allStatusForInsert = updatePpmScheduleTracksInsert.every(
                    (result) => result.status <= 204
                  );
                  if (allStatusForInsert) {
                    // setSaveCount(1);
                    setOpenDialog(true);
                    setPreventSaveDuplicateRecord(true);
                    // onClose();
                  }
                }
              } else if (location?.state?.mode != "edit" && yearValue !== Number(year?.value)) {
                setOpenDialog(true);
              }
              else if (location?.state?.mode === "edit") {
                //Console.log("EDIT MODE");
                const currentYearString = currentYear.toString();
                //Console.log(currentYearString, "currentYearString");

                let isDeleteTracks = false;
                const isYearChanged = location?.state?.schYear !== currentYearString;
                if (isChanged || isYearChanged) {

                  // if(!isYearChanged){

                  const updatePpmScheduleTracks = serviceType?.label === 'FEMS' ?
                    await RoutineInspectionRepository.removeRIScheduleTracks(
                      location?.state?.id
                    ) :
                    await RoutineInspectionRepository.removeBemsRIScheduleTracks(
                      location?.state?.id
                    );

                  if (updatePpmScheduleTracks.status <= 204) {
                    isDeleteTracks = true;
                  };
                  // };
                  //Console.log(isDeleteTracks, "isdeletetracks");

                  if (isDeleteTracks === true || isYearChanged) {
                    //Console.log("updated");

                    const generatedDates = await generateDates(
                      finalAgreedDate1,
                      period?.label,
                      response?.data?.id,
                      finalNextDate,
                      scheduledFrequency,
                      assignee?.id

                    );
                    //Console.log(generatedDates, "generatedDates");

                    const currentDate = new Date();
                    const filteredDates = generatedDates.filter(item => new Date(item.targetdate) > currentDate);
                    //Console.log(filteredDates, "filteredDates");
                    if (filteredDates && yearValue === Number(year?.value)) {

                      const setTracks = filteredDates?.map(async (item) => {
                        const updatePpmScheduleTracks =
                          serviceType?.label === 'FEMS' ?
                            await RoutineInspectionRepository.addRIscheduleTracks(item) : await RoutineInspectionRepository.addBemsRIscheduleTracks(item);
                        return updatePpmScheduleTracks;
                      });
                      const updatePpmScheduleTracksUpdate = await Promise.all(
                        setTracks
                      );
                      const allStatusForUpdate =
                        updatePpmScheduleTracksUpdate.every(
                          (result) => result.status <= 204
                        );
                      if (allStatusForUpdate) {
                        setOpenDialog(true);
                      }
                    }
                    else {
                      setLoading(false);
                      setOpenDialog(true);
                    }
                  }
                } else if (!isChanged) {
                  setOpenDialog(true);
                }
              
              }
            } else if (response.status === 401) {
              //Console.log("Unauthorized");
            }
            setLoading(false);
          }
        } else if (location?.state?.mode === "edit" && !isChanged) {
          //Console.log("EMPTY UPDATED");

          setOpenDialog(true);
        } else if (location?.state?.mode === "create" && preventSaveDuplicateRecord) {
          setOpenDialog(true);
        }

      }
    } catch (error) {
      //Console.log(error)

    }
    finally {
      setLoading(false);
    }

  };

  const validateField = async (name, fieldName) => {
    const namePattern = /^[^\s].*$/; // Ensures no leading space

    // Check if the input is empty or undefined
    if (name === '' || name === undefined || name === null) {
      return `${fieldName} is required`;
    }
    // Check if the input has a leading space
    if (!namePattern.test(name)) {
      return `Enter a valid ${fieldName}.`;
    }
    return ''; // Return an empty string if valid
  };
  const handleSubmit = async () => {
    const newErrors = {};
    const routineInspectionDetailsError = await validateField(routineInspectionDetails, 'Routine Inspection Details');
    if (!(routineInspectionDetailsError === '')) newErrors.routineInspectionDetails = routineInspectionDetailsError
    if (!workGroup) newErrors.workGroup = "Work Group is required"
    if (!serviceType) newErrors.serviceType = "Service Type is required";
    if (!year) newErrors.year = "Year is required";
    if (!taskCode?.label) newErrors.taskCode = "Task Code is required";
    if (assetNo?.label == '' || assetNo?.label == undefined) {
      if (!userLocationCode?.label) newErrors.userLocationCode = "User Location Code is required";
    }
    if (!period?.label) newErrors.period = "Period is required";
    if (!status?.label) newErrors.status = "Status is required";
    if (scheduledFrequency == 0) newErrors.scheduledFrequency = "Scheduled Frequency should be greater than zero";
    if (!agreedDate) newErrors.agreedDate = "Agreed Date is required";
    if (Object.keys(newErrors)?.length > 0) {
      setErrors(newErrors);
    } else {
      await handleSave();
      setIsChanged(false);
      setIsStatusRIDetailsChanged(false);
      setIsAssigneeTaskCodeChanged(false);
      setIsFrequencyDateChanged(false);
    }
  };
  const handleCloseDialog = () => {
    // setOpenDialogForSelectedCombination(false);
    setOpenDialog(false);
    setIsAddNew(false);
    setIsChanged(false);
    setDisableUpdateButton(true);
  };

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  const handleOpenModalForAsset = () => setIsModalOpenForAsset(true);
  const handleCloseModalForAsset = () => setIsModalOpenForAsset(false);


  return (
    <>
      <PageLoader open={loading} />
      <Box mt={{ xs: 1, sm: 2 }}>
        <DefaultCard>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <Typography variant='h5'>RI Setup Details</Typography></Grid>

            <Grid item xs={6} md={4}>
              <CustomSelectInput
                id="service-type-label"
                label="Service Type"
                isMandatoryField={true}
                value={serviceType}
                autoFocus={true}
                options={serviceTypeOptions}
                errorMessage={errors.serviceType}
                error={!!errors.serviceType}
                onChange={(newValue) => {

                  if (newValue?.label != '') {
                    setAssetNo({ value: '', label: '' });
                    setDisableAndMandatoryFieldHandleForUserLocation(false);
                    setAssetTypeCode("");
                    setAssetTypeCodeDescription("");
                    setUserLocationCode("");
                    setUserLocationCode({ label: '', value: '' });
                    setModel("");
                    setUserDepartment("");
                    setSerialNo("");
                    setAssetClassification("");
                    setAgreedDate('');
                    setNextDate('');
                    setRoutineInspectionDetails('');
                    setTaskCode({ label: '', value: '' });
                    setAssignee({ label: '', value: '' });
                    setStatus(statusOptions?.find((item) => item?.default === true));
                    setPeriod(periodOptions?.find((item) => item.label === "Weeks"));
                    setErrors((prevErrors) => ({ ...prevErrors, assetNo: "", status: "", serviceType: "", taskCode: "", typeCode: "", agreedDate: "", scheduledFrequency: "", period: "", assignee: "", year: "", routineInspectionDetails: "", userLocationCode: "" }));
                    setIsChanged(true);
                  }
                  setErrors({ ...errors, serviceType: "" });
                  setServiceType(newValue);
                }}
                disabled={location.state.mode === "view" || location.state.mode === "edit"}
              />
            </Grid>

            <Grid item xs={6} md={4}>
              <CustomSelectInput
                id="work-group-label"
                label="Work Group"
                isMandatoryField={true}
                value={workGroup}
                errorMessage={errors.workGroup}
                error={!!errors.workGroup}
                options={workGroupOptions}
                onChange={(newValue) => {
                  setErrors({ ...errors, workGroup: "" });
                  setWorkGroup(newValue);
                  if (newValue?.label != '') {
                    setAssetNo({ value: '', label: '' });
                    setDisableAndMandatoryFieldHandleForUserLocation(false);
                    setAssetTypeCode("");
                    setAssetTypeCodeDescription("");
                    setUserLocationCode("");
                    setUserLocationCode({ label: '', value: '' });
                    setModel("");
                    setUserDepartment("");
                    setSerialNo("");
                    setAssetClassification("");
                    setAgreedDate('');
                    setNextDate('');
                    setRoutineInspectionDetails('');
                    setTaskCode({ label: '', value: '' });
                    setAssignee({ label: '', value: '' });
                    setStatus(statusOptions?.find((item) => item?.default === true));
                    setPeriod(periodOptions?.find((item) => item.label === "Weeks"));
                    setErrors((prevErrors) => ({ ...prevErrors, assetNo: "", status: "", serviceType: "", taskCode: "", typeCode: "", agreedDate: "", scheduledFrequency: "", period: "", assignee: "", year: "", routineInspectionDetails: "", userLocationCode: "" }));
                    setIsChanged(true);
                  }
                  if (newValue?.label != '') {
                    workChangerunOnce.current = false;
                    setIsChanged(true);
                  }

                }}
                disabled={location.state.mode === "view" || location.state.mode === "edit"}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomSelectInput
                id="year-label"
                label="Year"
                isMandatoryField={true}
                value={year}
                errorMessage={errors.year}
                error={!!errors.year}
                options={yearOptions}
                onChange={(newValue) => {
                  setErrors({ ...errors, year: "" });
                  setYear(newValue);
                  if (newValue?.label != '') {
                    setIsChanged(true);
                  }

                }}
                disabled={location.state.mode === "view"}
              />
            </Grid>
            <Grid item xs={(location.state.mode === "view") ? 12 : 11.5} md={(location.state.mode === "view") ? 4 : 3.5} sm={(location.state.mode === "view") ? 6 : 5.5}>
              <CustomTextFieldWithSearch
                label="Asset No."
                id="assetno"
                value={assetNo}
                error={!!errors?.assetNo}
                errorMessage={errors.assetNo}
                options={assetOptions?.map(option => ({
                  ...option,
                  label: `${option.label} - ${option.assetdesc}`,
                }))?.sort((a, b) => a.label.localeCompare(b.label))
                }
                onChange={(newValue) => {
                  //Console.log(newValue, "newValue");
                  
                  runOnceForAssetChange.current = false;
                  let label = newValue?.label?.split(" - ")[0];
                  setAssetNo({ ...newValue, label: label });
                  //Console.log(newValue, "newValue");
                  

                  setUserLocationCode(userLocationCodeOptions?.find((item) => item?.label === newValue?.locationcode));
                  setUserDepartment(userLocationCodeOptions?.find((item) => item?.label === newValue?.locationcode)?.departmentdesc);
                  setUserLocationDescription(newValue?.locationdesc);
                  
                  if (newValue?.value === "") {
                    setDisableAndMandatoryFieldHandleForUserLocation(false);
                    setAssetTypeCode("");
                    setAssetTypeCodeDescription("");
                    setUserLocationDescription("");
                    setUserLocationCode("");
                    setUserLocationCode({ label: '', value: '' });
                    setModel("");
                    setUserDepartment("");
                    setSerialNo("");
                    setAssetClassification("");
                  }
                  if (newValue?.label !== "") {
                    setAssetTypeCode(newValue?.typecode);
                    setAssetTypeCodeDescription(newValue?.typedescription);
                    setModel(newValue?.model);
                    setSerialNo(newValue?.serialno);
                    setAssetClassification(newValue?.assetclassification);
                    setIsChanged(true);
                    assetNoForShowSchedule({ ...newValue, label: newValue?.value });
                    setDisableAndMandatoryFieldHandleForUserLocation(true);
                    setErrors({ ...errors, assetNo: null, userLocationCode: '' });
                  }
                }}
                disabled={location.state.mode === "view" || location.state.mode === "edit" || disableAndMandatoryFieldHandleForAssetNo}
              />
            </Grid>

            {(location.state.mode != "view") && (<Grid item xs={0.5} md={0.5} sm={0.5} >
              {location.state.mode != "view" && (
                <Grid sx={{ mt: 2.7 }} item>
                  <Button
                    onClick={handleOpenModalForAsset}
                    variant="contained"
                    sx={{ minWidth: '32px', minHeight: '32px', marginLeft: '0rem' }}
                    disabled={location.state.mode === "view" || location.state.mode === "edit" || disableAndMandatoryFieldHandleForAssetNo}>
                    <SearchIcon fontSize="small" />
                  </Button>
                </Grid>
              )}

              <Dialog
                open={isModalOpenForAsset}
                onClose={(event, reason) => {
                  if (reason === "backdropClick") {
                    return; // Prevent closing on backdrop click
                  }
                  handleCloseModalForAsset(); // Call the close function for other reasons
                }}
                // onClose={handleCloseModal}
                aria-labelledby="asset-grid-dialog"
                aria-describedby="grid-display-for-assets"
                maxWidth="lg"
                fullWidth
              ><DialogTitle
                id="asset-grid-dialog"
                sx={{
                  fontWeight: 'bold',
                  fontSize: '1.5rem', // Adjust font size as desired
                  display: 'flex',
                  justifyContent: 'space-between', // Space out title and icon
                  alignItems: 'center',
                }}
              >
                  Asset Search
                  <IconButton
                    aria-label="close"
                    variant="outlined"
                    onClick={handleCloseModalForAsset}
                    sx={{
                      color: (theme) => theme.palette.grey[500],
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent
                  dividers
                  sx={{
                    overflowY: 'auto', // Enables scroll if content overflows
                    height: 'auto',    // Allows height to adjust based on content
                    maxHeight: 'auto', // Sets a maximum height to prevent it from growing too large
                  }}
                >
                  <CustomAgGrid
                    rows={assetOptions || []}
                    columns={columns}
                    // loading={loadingAssets}
                    refSet={gridApi}
                    setGridApi={setGridApi}
                  />
                  <Stack my={3} direction={"row"} justifyContent={"end"}>
                    <Button variant="outlined" onClick={handleCloseModalForAsset}>
                      Close
                    </Button>
                  </Stack>
                </DialogContent>
              </Dialog>

            </Grid>
            )}
            <Grid item xs={6} md={4}>
              <CustomTextField
                maxlength={225}
                label="Asset Type Code"
                id="assettypecode"
                value={assetTypeCode}
                disabled={true}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomTextField
                maxlength={225}
                label="Asset Type Code Description"
                id="assettypecodedescription"
                value={assetTypeCodeDescription}
                disabled={true}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomTextFieldWithSearch
                label="Location Code"
                id="userlocationcode"
                value={userLocationCode}
                //disabled={true}
                error={!!errors?.userLocationCode}
                errorMessage={errors.userLocationCode}
                options={userLocationCodeOptions?.map(option => ({
                  ...option,
                  label: `${option.label} - ${option.locationdesc}`,
                }))?.sort((a, b) => a.label.localeCompare(b.label))
                }
                onChange={(newValue) => {
                  let label = newValue?.label?.split(" - ")[0];
                  setUserLocationCode({ ...newValue, label: label });
                  setUserLocationDescription(newValue?.locationdesc);
                  setUserDepartment(newValue?.departmentdesc);

                  setDisableAndMandatoryFieldHandleForAssetNo(true);
                  if (newValue?.label !== "") {
                    setIsChanged(true);
                    assetNoForShowSchedule({ ...newValue, label: newValue?.value });
                    setErrors({ ...errors, userLocationCode: null, assetNo: null });
                  } else if (newValue?.label === "") {
                    setDisableAndMandatoryFieldHandleForAssetNo(false);
                    setUserLocationDescription("");
                    setUserDepartment("");
                  }
                }}
                // disabled={location.state.mode==="view" || disableAndMandatoryFieldHandleForUserLocation }
                disabled={location.state.mode === "view" || location.state.mode === "edit" || disableAndMandatoryFieldHandleForUserLocation}

                isMandatoryField={!disableAndMandatoryFieldHandleForUserLocation}
                disableplaceholder={disableAndMandatoryFieldHandleForUserLocation}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomTextField
                maxlength={225}
                label="Location Description"
                id="userlocationdesc"
                value={userLocationDescription}
                disabled={true}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomTextField
                label="Department Description"
                id="userdepartment"
                // isRefilByOtherField={true}
                placeholder={false}
                value={userDepartment}
                disabled={true}
              />
            </Grid>

            <Grid item xs={6} md={4}>
              <CustomTextField
                maxlength={225}
                label="Model"
                id="model"
                value={model}
                disabled={true}
              />
            </Grid>

            <Grid item xs={6} md={4}>
              <CustomTextField
                maxlength={225}
                label="Serial No."
                id="serialno"
                value={serialNo}
                disabled={true}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomTextField
                maxlength={225}
                label="Asset Classification"
                id="assetClassification"
                value={assetClassification}
                disabled={true}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomTextFieldWithSearch
                label="Assignee"
                value={assignee}
                options={assigneeOptions?.map(option => ({
                  ...option,
                  label: `${option?.employeecode}-${option?.label}`,

                }))?.sort((a, b) => a.label.localeCompare(b.label))
                }
                onChange={(newValue) => {
                  setAssignee(newValue?.value !== '' ? { ...newValue, label: newValue.value } : '');
                  if (newValue?.label !== "") {
                    setErrors({ ...errors, assignee: null });
                    setIsChanged(true);
                    setIsAssigneeTaskCodeChanged(true);
                  }
                }}
                // isMandatoryField={true}
                error={errors.assignee}
                errorMessage={errors.assignee}
                disabled={location.state.mode === "view"}
              />
            </Grid>

            <Grid item xs={(location.state.mode == "view") ? 12 : 11.5} md={(location.state.mode == "view") ? 4 : 3.5} sm={(location.state.mode == "view") ? 6 : 5.5} >
              <CustomTextFieldWithSearch
                isMandatoryField={true}
                error={!!errors?.taskCode}
                errorMessage={errors.taskCode}
                label="Task Code"
                id="tc-no"
                value={taskCode}
                options={taskCodeOptions?.map(option => ({
                  ...option,
                  label: `${option.label} - ${option.taskdesc}`,
                  value: option.value,
                }))?.sort((a, b) => a.label.localeCompare(b.label))
                }
                onChange={(newValue) => {

                  setTaskCode({ ...newValue, label: newValue?.value });

                  if (newValue?.label !== "") {
                    taskCodeForShowSchedule(newValue?.value);
                    setErrors({ ...errors, taskCode: null });
                    setIsChanged(true);
                    setIsAssigneeTaskCodeChanged(true);
                  }
                }}
                disabled={location.state.mode === "view"}
              />
            </Grid>

            {(location.state.mode != "view") && (<Grid item xs={0.5} md={0.5} sm={0.5} >
              {location.state.mode != "view" && (
                <Grid sx={{ mt: 2.7 }} item>
                  <Button
                    onClick={handleOpenModal}
                    variant="contained"
                    sx={{ minWidth: '32px', minHeight: '32px', marginLeft: '0rem' }}
                    disabled={location.state.mode == "view"}>
                    <SearchIcon fontSize="small" />
                  </Button>
                </Grid>
              )}

              <Dialog
                open={isModalOpen}
                onClose={(event, reason) => {
                  if (reason === "backdropClick") {
                    return; // Prevent closing on backdrop click
                  }
                  handleCloseModal(); // Call the close function for other reasons
                }}
                aria-labelledby="asset-grid-dialog"
                aria-describedby="grid-display-for-assets"
                maxWidth="lg"
                fullWidth
              ><DialogTitle
                id="asset-grid-dialog"
                sx={{
                  fontWeight: 'bold',
                  fontSize: '1.5rem', // Adjust font size as desired
                  display: 'flex',
                  justifyContent: 'space-between', // Space out title and icon
                  alignItems: 'center',
                }}
              >
                  Task Code Search
                  <IconButton
                    aria-label="close"
                    variant="outlined"
                    onClick={handleCloseModal}
                    sx={{
                      color: (theme) => theme.palette.grey[500],
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent
                  dividers
                  sx={{
                    overflowY: 'auto', // Enables scroll if content overflows
                    height: 'auto',    // Allows height to adjust based on content
                    maxHeight: 'auto', // Sets a maximum height to prevent it from growing too large
                  }}
                >
                  <CustomAgGrid
                    rows={taskCodeOptions || []}
                    columns={columnsTaskCode}
                    // loading={loadingAssets}
                    refSet={gridAPIS}
                    setGridApi={setGridAPIS}
                  />
                  <Stack my={3} direction={"row"} justifyContent={"end"}>
                    <Button variant="outlined" onClick={handleCloseModal}>
                      Close
                    </Button>
                  </Stack>
                </DialogContent>
              </Dialog>

            </Grid>)}
            <Grid item xs={6} md={4}>
              <CustomSelectInput
                label="Period"
                isMandatoryField={true}
                value={period}
                error={!!errors?.period}
                errorMessage={errors.period}
                options={periodOptions || []}
                onChange={(newValue) => {
                  onChangeHandle(newValue, "period");
                  //  setIsFilledAllMandatoryField(false);
                  setPeriod(newValue);
                  setPeriodForShowSchedule(newValue?.label);
                  if (newValue?.label !== "") {
                    setErrors({ ...errors, period: null });
                    setIsChanged(true);
                    setIsFrequencyDateChanged(true);
                  }
                }}
                disabled={location.state.mode === "view"}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomTextField
                onlyNumbers={true}
                isMandatoryField={true}
                id="schdulefrequency"
                label="Schedule Frequency"
                value={scheduledFrequency}
                error={!!errors?.scheduledFrequency}
                errorMessage={errors.scheduledFrequency}
                onChange={(newValue) => {
                  onChangeHandle(Number(newValue) + 0, "scheduledfrequency");
                  // setIsFilledAllMandatoryField(false);
                  setScheduledFrequency(Number(newValue) + 0);
                  if (newValue !== "") {
                    setIsChanged(true);
                    setIsFrequencyDateChanged(true);
                    setErrors({ ...errors, scheduledFrequency: null });
                  }
                  //scheduledFrequencyRef.current = newValue
                }}
                disabled={location.state.mode === "view"}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomSelectInput
                id="status"
                label="Status"
                isMandatoryField={true}
                value={status}
                options={statusOptions}
                errorMessage={errors.status}
                error={!!errors.status}
                onChange={(newValue) => {
                  if (newValue?.label != '') {
                    setIsChanged(true);
                    setErrors({ ...errors, status: "" });
                    setIsStatusRIDetailsChanged(true);
                  }
                  setStatus(newValue);
                }}
                disabled={location.state.mode === "view"}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomDatePicker
                label="Agreed Date"
                isStatrtDate={true}
                dissablePastDate={true}
                id={"agreed-date"}
                isMandatoryField={true}
                value={agreedDate}
                error={!!errors?.agreedDate}
                errorMessage={errors.agreedDate}
                onDateChange={(newValue) => {
                  onChangeHandle(newValue, "agreedDate");
                  setAgreedDate(newValue);
                  setIsChanged(true);
                  setIsFrequencyDateChanged(true);
                  setErrors({ ...errors, agreedDate: null });
                }}
                disabled={location.state.mode === "view"}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomTextField
                maxlength={225}
                label="Next Date"
                id="nextDate"
                value={nextDate}
                disabled={true}
              />
            </Grid>

            <Grid item xs={6} md={8}>
              <CustomTextArea
                maxlength={255}
                isMandatoryField={true}
                label="Routine Inspection Details"
                id="routine_insection_details"
                value={routineInspectionDetails}
                onChange={newValue => {
                  validateField(newValue, "Routine Inspection Details")
                  setRoutineInspectionDetails(newValue)
                  if (newValue !== "") {
                    setErrors({ ...errors, routineInspectionDetails: null });
                    setIsChanged(true);
                    setIsStatusRIDetailsChanged(true);
                  };

                }}
                disabled={location.state.mode === "view"}
                error={!!errors?.routineInspectionDetails}
                helperText={errors.routineInspectionDetails}
              />
            </Grid>

          </Grid>

          <Box
            sx={{
              marginTop: "30px",
              display: "flex",
              gap: 2,
              justifyContent: { xs: "center", md: "end" },
            }}
          >
            <ActionButtons
              handleSubmit={handleSubmit}
              handleCancel={handleCancel}
              handleAddNew={handleAddNew}
              enableSubmit={!disableUpdateButton}
              isEdit={location.state.mode === "edit"}
              isView={location.state.mode === "view"}
              updateLabel={((location.state.changeHeaderAndButtonName === false) || (location.state.mode === "edit")) ? "Update" : "Save"}
              SaveLabel={"Save"}
            />
          </Box></DefaultCard></Box>
      <CustomDialog
        open={cancelDialogOpen}
        onClose={() => setCancelDialogOpen(false)}
        title="Unsaved Changes"
        content="Record(s) not Saved/Updated. Do you want to continue?"
        confirmBtn="Yes"
        cancelBtn="No"
        onConfirm={handleCancelDialogConfirm}
        onCancel={() => setCancelDialogOpen(false)}
      />
      <CustomDialog
        open={openDialog}
        onClose={handleCloseDialog}
        content={location?.state.mode !== "edit" ? "Data saved successfully." : "Data updated successfully."}
        confirmBtn={"OK"}

        onConfirm={handleCloseDialog}
      />
    </>
  )
};
export default RoutineInspectionCreate



